import { Button } from 'primereact/button';
import AdCreative from '../AdCreative';
import '../App.css';

function CampaignNewStepPreview({
    setStep,
    previewURL,
    maxSecondsToDisplay,
}) {
    return (
        <div>
            <div className='mk2-title'>
                Preview
            </div>
            <div>
                <div style={{ width: '30em' }}>
                    <AdCreative
                        creativeURL={previewURL}
                        creativeExt='png'
                    />
                </div>
            </div>
            <div style={{ marginTop: '1em' }}>
                <Button
                    label="Back"
                    severity="secondary"
                    onClick={
                        () => {
                            setStep('upload');
                        }
                    }
                    style={{ marginRight: '0.5em' }}
                    size='small'
                    outlined
                />
                <Button
                    label='Continue'
                    severity='success'
                    onClick={() => setStep('set_time_to_display')}
                    disabled={maxSecondsToDisplay == null || maxSecondsToDisplay <= 0}
                    size='small'
                    outlined
                />
            </div>
        </div>
    );
}

export default CampaignNewStepPreview;